type Props = {
  modifiers: string[];
  comment?: string | null;
};

/**
 * The lines under a product on a card: its modifiers, then the kitchen note. The note is set at the
 * same size and weight as a modifier — on a kitchen screen it is another instruction, not an aside.
 */
const ItemModifiers = ({ modifiers, comment }: Props) => {
  if (modifiers.length === 0 && !comment) return null;

  return (
    <ul className="m-0 p-0 pl-5 list-none flex flex-col gap-0.5 text-grey-dark">
      {modifiers.map((modifier, index) => (
        <li key={index} className="flex gap-1 items-baseline">
          <span className="text-grey-medium">→</span>
          {modifier}
        </li>
      ))}
      {comment && <li>{comment}</li>}
    </ul>
  );
};

export default ItemModifiers;
